export default __webpack_public_path__ + "static/media/RosanaRodrigues_03.3a86891f.jpg";